<div class="page-post-closure">
  <div class="background-page"></div>
  <div id="left-side" class="left-side">
    <div class="conference-warning-block">
      <div class="conference-warning-message" [innerHTML]="postClosureText | safeHTML">
      </div>
    </div>
  </div>
  <div id="right-side" class="right-side">
    <div class="auth-box">
      <img class="logo" *ngIf="data?.fileAuthentication?.url" [src]="data?.fileAuthentication?.url" alt=""/>
      <div class="header">
        <h2>{{ data?.titleAuthentication }}</h2>
        <p>{{ data?.subtitleAuthentication }}</p>
      </div>
      <div class="social-login">
        <button class="cidadao" (click)="signInAcessoCidadao()">
          <span style="width: 100%; justify-content: center;display: flex;align-items: center;">
            <img src="assets/images/govbrbranco.png"  />
            <img src="assets/icons/cidadao.svg" alt=""/>
            Acessar com GOV.BR ou ACESSO CIDADÃO
        </span>
        </button>
  
      </div>
      <a href="/#/how-it-works-slim" target="blank" class="how-it-works-container">Saiba como
        participar</a>
        <div class="policy-container">
          <a class="policy-link" target="blank" href="assets/docs/privacy-policy.html">Política de Privacidade</a>
        </div>
        <div class="or">
          <img class="poweredBy" src="assets/images/poweredBy.svg" alt="">
        </div>
    </div>
  </div>
  <div id="login-mobile">
    <div class="login-mobile">
      <div class="button-position">
        <button class="submit" (click)="changeToLoginForm()">Entrar</button>
      </div>
      <div class="actions">
        <div>
          <a [routerLink]="['/register']">Cadastre-se</a>
        </div>
        <div>
          <a [routerLink]="['/forgot-password']">Esqueceu sua senha?</a>
        </div>
      </div>
    </div>
  </div>
</div>
